import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createRegularusersGroup({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.create, data: values });

    onSuccess();
    yield put(actions.createRegularusersGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createRegularusersGroupFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.create.url
    });
  }
}

export const createRegularusersGroupSaga = takeEvery(types.CREATE_REGULARUSERS_GROUP_REQUEST, createRegularusersGroup);